export const CDC_MULTIPLE_SETTINGS = {
    singleSelection: false,
    enableCheckAll: false,
    enableSearchFilter: true,
    primaryKey: 'code',
    labelKey: 'code',
    searchBy: ['code'],
    classes: 'form-control a2-mu-xs',
    lazyLoading: true,
    showCheckbox: true,
    text: 'Seleziona centro di costo',
    noDataLabel: '',
    searchAutofocus: true
};

export const CDC_SINGLE_SETTINGS = {
    singleSelection: true,
    enableCheckAll: false,
    enableSearchFilter: false,
    primaryKey: 'code',
    labelKey: 'code',
    searchBy: ['code'],
    classes: 'form-control a2-mu-xs',
    lazyLoading: true,
    showCheckbox: true,
    text: 'Seleziona centro di costo',
    noDataLabel: '',
    searchAutofocus: false
};